import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import withRest from 'frontend_core/dist/api/rest/withRest'

export default function(
  container,
  mapStateToProps,
  mapDispatchToProps,
  { graphql },
) {
  let WrappedComponent = graphql ? graphql(container) : container
  WrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WrappedComponent)
  WrappedComponent = withRouter(WrappedComponent)
  WrappedComponent = withRest(WrappedComponent)

  class WithPage extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />
    }
  }
  if (typeof window === 'undefined' && container.getInitialProps) {
    WithPage.getInitialProps = container.getInitialProps
  }
  return WithPage
}
